import isSupportsWebp from '../helpers/isSupportsWebp';
import initPsw from '../photoswipe/photoswipe';
import { sendEvent } from '../helpers/analytics';

const eventAction = 'fullscreen_gallery';

class GalleryFullscreen {
  constructor(source, onInit = () => {}) {
    this.data = [];
    this.source = source;
    this.onInit = onInit;

    this.init();
  }

  init() {
    isSupportsWebp('lossy', (_, supportsWebp) => {
      this.data = this.source
        .filter((image) => !image.logo)
        .map((image) => {
          const src = window.isMobile ? image.x2_mobile : image.x2;

          return {
            w: image.fs_width,
            h: image.fs_height,
            src: `${src}${supportsWebp ? '.webp' : ''}`,
            title: image.title,
          };
        });

      this.onInit(this.data);
    });
  }

  initPsw(currentIndex) {
    if (this.data.length === 0) return;

    const psw = initPsw(this.data, currentIndex);
    if (!psw) return;

    let prevItem = 0;
    const totalItems = psw.options.getNumItemsFn();
    const lastItem = totalItems - 1;

    psw.listen('afterChange', () => {
      const currItem = psw.getCurrentIndex();
      if (prevItem === lastItem && currItem === 0) this.fireGaEvent('next_click');
      else if (prevItem === 0 && currItem === lastItem) {
        this.fireGaEvent('prev_click');
      } else if (currItem > prevItem) {
        this.fireGaEvent('next_click');
      } else if (currItem < prevItem) {
        this.fireGaEvent('prev_click');
      }

      prevItem = currItem;
    });
  }

  fireGaEvent(eventLabel) {
    sendEvent(window.eventCategory, eventAction, eventLabel);
  }
}

export default GalleryFullscreen;
